import React, { useState } from "react";
import ReceptionistLayout from "../../Layouts/Receptionist/ReceptionistLayout";

export default function ReceptionistProfile() {
    const [formData, setFormData] = useState({
        name: "Geetha Receptionist",
        email: "geetha@hospital.com",
        phone: "9876543210",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(formData);
    };

    return (
        <ReceptionistLayout>
            <div className="row g-4">
                <div className="col-12">
                    <div className="card border rounded-4 shadow-sm">
                        <div className="card-body p-4 p-lg-5">
                            <form onSubmit={handleSubmit}>
                                <div className="row g-4">
                                    <div className="col-12">
                                        <label className="form-label fw-semibold mb-1">
                                            Name
                                        </label>
                                        <input
                                            type="text"
                                            name="name"
                                            className="form-control"
                                            value={formData.name}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-12">
                                        <label className="form-label fw-semibold mb-1">
                                            Email
                                        </label>
                                        <input
                                            type="email"
                                            name="email"
                                            className="form-control"
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-12">
                                        <label className="form-label fw-semibold mb-1">
                                            Phone
                                        </label>
                                        <input
                                            type="text"
                                            name="phone"
                                            className="form-control"
                                            value={formData.phone}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-12">
                                        <button
                                            type="submit"
                                            className="btn btn-primary w-100 btn-sm fw-bold py-3 rounded-3"
                                        >
                                            Update Profile
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </ReceptionistLayout>
    );
}
